const GetAreaId = (areaType) => {
  if (areaType === "Urban" || areaType === "शहरी") {
    return 1;
  } else if (areaType === "Rural" || areaType === "ग्रामीण") {
    return 2;
  } else {
    return null;
  }
};

export default GetAreaId;
export const setSessionItemFunction = (key, value) => {
  if (value) {
    sessionStorage.setItem(key, value);
  }
};
